import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { DataFlowExpression } from './dataflowexpression';
import { Owned } from '../base/named';

@Metamodel.model({
    name: 'assertExpression'
})
export class AssertExpression extends Owned {
    public static readonly MODEL: IModel;

    public guid: string;

    @Metamodel.attribute({
        display: stringResources.AssertType
    })
    public assertType: string = 'expectTrue';

    @Metamodel.attribute({
        display: stringResources.AssertId
    })
    public assertId: string = '';

    @Metamodel.attribute({
        display: stringResources.AssertDescription
    })
    public assertDescription: DataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);

    @Metamodel.attribute({
        display: stringResources.DataFlowIgnoreNullsLabel
    })
    public ignoreNulls: boolean;

    @Metamodel.attribute({
        display: stringResources.Filter
    })
    public filterExpression: DataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);

    @Metamodel.attribute({
        display: stringResources.ExpectTrueExpression
    })
    public trueExpression: DataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);

    @Metamodel.attribute({
        display: stringResources.ExpectUniqueExpressions
    })
    public uniqueExpressions: DataFlowExpression[] = [Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this)];

    @Metamodel.attribute({
        display: stringResources.ExpectExistsLeftExpression
    })
    public existsLeftExpression: DataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);

    @Metamodel.attribute({
        display: stringResources.ExpectExistsRightExpression
    })
    public existsRightExpression: DataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);
}
